/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { object } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import { useUIDSeed } from 'react-uid';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LazyLoadWrapper from '../GraphqlCommonComponents/LazyLoadWrapper/LazyLoadWrapper';
import GraphqlSlider from '../GraphqlCommonComponents/GraphqlSlider/GraphqlSlider';
import ResponsiveImage from '../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import data from './ViewData';

const styles = (theme) => ({
    header: {
        fontSize: '30px',
        textAlign: 'center',
        display: 'block',
        marginTop: '10px',
    },
    arrowIcon: {
        fontSize: '35px',
    },
    modal: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
        },
        '& button:first-child': {
            left: '115px',
            zIndex: '111',
            [theme.breakpoints.down('sm')]: {
                left: '10px',
            },
        },
        '& button:last-child': {
            right: '115px',
            zIndex: '111',
            [theme.breakpoints.down('sm')]: {
                right: '15px',
            },
        },
        '& img': {
            width: '63%',
        },
    },
    gallery: {
        width: '25%',
        display: 'inline-flex',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '50%',
        },
    },
    galleryImage: {
        width: '100%',
        objectFit: 'cover',
        minHeight: '100%',
        [theme.breakpoints.down('xs')]: {
            height: '100%',
        },
    },
    modalContainer: {
        '& >div>div': {
            width: '100%',
            maxWidth: '770px',
        },
    },
    closeButton: {
        width: '100%',
        textAlign: 'right',
    },
    close: {
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    backButton: {
        padding: '1% 0 0 0.8%',
        textDecoration: 'none',
        display: 'block',
        color: theme?.palette?.common?.black,
        [theme.breakpoints.down('sm')]: {
            padding: '3% 0 0 1%',
        },
    },
    back: {
        display: 'flex',
        '& svg': {
            width: '20px',
            maxHeight: '23px',
        },
    },
    extraPadding: {
        padding: 10,
    },
});
const getSlides = (items) => {
    const slides = [];
    const seed = useUIDSeed();
    items.forEach((list) => {
        slides.push(
            (
                <div
                    key={seed(list)}
                >
                    <img src={list.image} alt={list.alt} />
                </div>
            ),
        );
    });
    return slides;
};

const KristinaLibbyGalleryPage = ({ classes }) => {
    const {
        slider,
        header,
        url,
    } = data;
    if (!data) return null;
    const seo = {
        page_title: 'Image Gallery of Floral Hearts by Artist Kristina Libby | 1800Flowers',
        keywords: 'flower image gallery kristina libby',
        meta_description: ' Inspiration in art comes to life in this heartfelt flower image gallery of Floral Hearts by Kristina Libby',
        location: { pathname: '/kristina-libby-flower-heart-images' },
    };
    const [selctedImageIndex, setSelectedImage] = useState(0);
    const [isShowing, setIsShowing] = useState(false);
    const seed = useUIDSeed();
    function toggle(index) {
        setSelectedImage(index);
        setIsShowing(!isShowing);
    }
    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <Grid container className={classes.container}>
                <Grid item xs={12}>
                    <Link to={url} className={classes.backButton}>
                        <span
                            className={classes.back}
                        >
                            <svg
                                viewBox="0 0 24 24"
                                fill="#1f1f1b"
                                preserveAspectRatio="xMidYMid meet"
                                focusable="false"
                                className={classes.leftArrow}
                            >
                                <g>
                                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                </g>
                            </svg>
                            <div>Back</div>
                        </span>
                    </Link>
                    <h1 className={classes.header}>
                        {header}
                    </h1>
                </Grid>
                <Grid item xs={12}>
                    <Grid container className={classes.contentGallery}>
                        {
                            slider.map((list, index) => (
                                <Grid className={classes.gallery} item xs={6} sm={6} md={3} lg={3} key={seed(list)} onClick={() => toggle(index)} onKeyDown={() => { }} role="button" tabIndex={-1} aria-label={`Image-Slider-${index}`}>
                                    <LazyLoadWrapper
                                        config={{
                                            once: true,
                                            offset: 200,
                                            height: 100,
                                        }}
                                    >
                                        <ResponsiveImage
                                            path={index <= 91 ? `${list.image}?height=467&auto=webp` : list.image}
                                            alt={list.alt}
                                            className={index <= 91 ? `${classes.extraPadding} ${classes.galleryImage}` : classes.galleryImage}
                                        />
                                    </LazyLoadWrapper>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Dialog open={isShowing} className={classes.modalContainer}>
                        <div className={classes.closeButton}>
                            <IconButton className={classes.close} aria-label="Close" onClick={() => toggle()}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <div className={classes.modal}>
                            <GraphqlSlider
                                items={getSlides(slider)}
                                itemsPerSlide={1}
                                selectedIndex={selctedImageIndex}
                                prevLink={(
                                    <ArrowBackIosIcon className={classes.arrowIcon} />
                                )}
                                nextLink={(
                                    <ArrowForwardIosIcon className={classes.arrowIcon} />
                                )}
                                loop
                            />
                        </div>
                    </Dialog>
                </Grid>
            </Grid>

        </>
    );
};

KristinaLibbyGalleryPage.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(KristinaLibbyGalleryPage);
